import { Fragment, useMemo } from "react";

import { getMenuPayloadSnapshot, safeStringifyForScript } from "@/lib/menu-preload";

export default function MenuPreloadScripts() {
  const payload = useMemo(() => getMenuPayloadSnapshot(), []);
  if (!payload) {
    return null;
  }

  const entries = Object.entries(payload).filter(([, data]) => data && Object.keys(data).length > 0);
  if (entries.length === 0) {
    return null;
  }

  return (
    <Fragment>
      {entries.map(([localeKey, data]) => {
        const id = `__PR_MENUS_${localeKey.toUpperCase()}`;
        const normalizedKey = localeKey.toLowerCase();
        const payload = safeStringifyForScript(data);
        const assignScript = [
          "window.__PRERENDER_MENUS__ = window.__PRERENDER_MENUS__ || {};",
          `window.__PRERENDER_MENUS__[${JSON.stringify(normalizedKey)}] = ${payload};`,
        ].join(" ");

        return (
          <Fragment key={localeKey}>
            <script
              id={id}
              type="application/json"
              dangerouslySetInnerHTML={{ __html: payload }}
              suppressHydrationWarning
            />
            <script
              type="application/javascript"
              dangerouslySetInnerHTML={{ __html: assignScript }}
              suppressHydrationWarning
            />
          </Fragment>
        );
      })}
    </Fragment>
  );
}
